import { defineComponent as _defineComponent } from 'vue'
import { PlatformLinkInterface } from '~/pages/podcasts.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PodcastLinks',
  props: {
    links: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})